import { Button, Col, ControlLabel, Form, FormControl, FormGroup, HelpBlock, Panel } from 'react-bootstrap'

import { MACROMOLECULE_WELCOME_VIEW } from '../../../constants/saxs'
import PropTypes from 'prop-types'
import React from 'react'
import { getMacromoleculeByAcronym } from '../../../helpers/Saxs/SaxsProposalManager'

/**
 * React Component used to create or EDIT a macromolecule.
 */
class SaxsNewOrEditMacromolecule extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      helpBlockMessages: {
        acronym: '',
        comments: '',
        extintionCoefficient: '',
        molecularMass: '',
        name: '',
        proposal: '',
        refractiveIndex: '',
        solventViscosity: '',
        symmetry: '',
      },
      macromolecule: this.props.selectedMacromolecule,
      selectedMacromolecule: this.props.selectedMacromolecule,
      validationStates: {
        acronym: null,
        comments: null,
        extintionCoefficient: null,
        molecularMass: null,
        name: null,
        proposal: null,
        refractiveIndex: null,
        solventViscosity: null,
        symmetry: null,
      },
    }

    this.onSaveButtonClicked = this.onSaveButtonClicked.bind(this)
    this.getCurrentMacromoleculeFormValidationState = this.getCurrentMacromoleculeFormValidationState.bind(this)
    this.setMacromolecule = this.setMacromolecule.bind(this)
  }

  render() {
    return (
      <div>
        <h2 className="landing-title">
          {this.state.macromolecule.macromoleculeId === null ? 'New' : 'Edit'} macromolecule
        </h2>

        <Panel eventKey="1">
          <Panel.Heading>
            <Panel.Title toggle>General</Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <MacromoleculeForm
              activeProposal={this.props.activeProposal}
              helpBlockMessages={this.state.helpBlockMessages}
              macromolecule={this.state.macromolecule}
              setMacromolecule={this.setMacromolecule}
              validationStates={this.state.validationStates}
            />
          </Panel.Body>
        </Panel>
        {this.state.macromolecule.macromoleculeId !== null ? (
          <Panel eventKey="2">
            {/* we are editing a macromolecule */}
            <Panel.Heading>
              <Panel.Title toggle>Advanced</Panel.Title>
            </Panel.Heading>
            <Panel.Body collapsible>
              <RigidBodyModelingForm />
            </Panel.Body>
          </Panel>
        ) : null}

        <div style={{ padding: '20px' }}>
          <Button bsStyle="primary" className="pull-right" onClick={this.onSaveButtonClicked}>
            Save
          </Button>
          <Button
            bsStyle="primary"
            className="pull-right"
            style={{ marginRight: '10px' }}
            onClick={() => this.props.setView(MACROMOLECULE_WELCOME_VIEW)}
          >
            Cancel
          </Button>
        </div>
      </div>
    )
  }

  getCurrentMacromoleculeFormValidationState() {
    const newValidationStates = {
      acronym: null,
      comments: null,
      extintionCoefficient: null,
      molecularMass: null,
      name: null,
      proposal: null,
      refractiveIndex: null,
      solventViscosity: null,
      symmetry: null,
    }

    const newHelpBlockMessages = {
      acronym: '',
      comments: '',
      extintionCoefficient: '',
      molecularMass: '',
      name: '',
      proposal: '',
      refractiveIndex: '',
      solventViscosity: '',
      symmetry: '',
    }

    if (this.state.macromolecule.name === '') {
      newValidationStates.name = 'error'
    }
    if (this.state.macromolecule.acronym === '') {
      newValidationStates.acronym = 'error'
    }

    // Validation fails during creation of a macromolecule and the acronym already exists.
    if (
      !this.state.macromolecule.macromoleculeId &&
      getMacromoleculeByAcronym(this.state.macromolecule.acronym, this.props.proposalInfo.data) !== null
    ) {
      newValidationStates.acronym = 'error'
      newHelpBlockMessages.acronym = 'Duplicated acronym. Change the acronym.'
    }

    return { validationStates: newValidationStates, helpBlockMessages: newHelpBlockMessages }
  }

  onSaveButtonClicked() {
    // check that input values are valid
    const validationStatesAndHelpBlockMessages = this.getCurrentMacromoleculeFormValidationState()

    if (
      validationStatesAndHelpBlockMessages.validationStates.acronym !== null ||
      validationStatesAndHelpBlockMessages.validationStates.comments !== null ||
      validationStatesAndHelpBlockMessages.validationStates.extintionCoefficient !== null ||
      validationStatesAndHelpBlockMessages.validationStates.molecularMass !== null ||
      validationStatesAndHelpBlockMessages.validationStates.name !== null ||
      validationStatesAndHelpBlockMessages.validationStates.proposal !== null ||
      validationStatesAndHelpBlockMessages.validationStates.refractiveIndex !== null ||
      validationStatesAndHelpBlockMessages.validationStates.solventViscosity !== null ||
      validationStatesAndHelpBlockMessages.validationStates.symmetry !== null
    ) {
      // the macromolecule form is not valid, needs user's feedback
      this.setState({
        validationStates: validationStatesAndHelpBlockMessages.validationStates,
        helpBlockMessages: validationStatesAndHelpBlockMessages.helpBlockMessages,
      })
    } else {
      // the macromolecule form is valid
      this.props.onSaveButtonClicked({ ...this.state.macromolecule, proposal: undefined })
    }
  }

  setMacromolecule(macromolecule) {
    this.setState({ macromolecule: macromolecule })
  }

  componentDidUpdate() {
    if (this.props.selectedMacromolecule.macromoleculeId !== this.state.selectedMacromolecule.macromoleculeId) {
      this.setState({
        macromolecule: this.props.selectedMacromolecule,
        selectedMacromolecule: this.props.selectedMacromolecule,
      })
    }
  }
}

SaxsNewOrEditMacromolecule.propTypes = {
  /** When privided, it corresponds to the macromolecule which is edited. As such, it also informs about whether the current component is used
   * to create (macromolecule is null) or to edit (macromolecule is not null) */
  macromolecule: PropTypes.object,
  /** Function triggered when the user clicks on the save button */
  onSaveButtonClicked: PropTypes.func,
}

/**
 * React compoent which renders the macromolecule form
 */
class MacromoleculeForm extends React.Component {
  constructor(props) {
    super(props)

    this.handleInputChange = this.handleInputChange.bind(this)
  }

  render() {
    return (
      <Form horizontal>
        <FormItem
          disabled
          inputType="text"
          label="Proposal"
          name="proposal"
          onChange={this.handleInputChange}
          value={this.props.activeProposal ? this.props.activeProposal : 'not set'}
          validationState={this.props.validationStates.proposal}
        />

        <FormItem
          helpText="Long name. i.e: Bovine serum albumin"
          inputType="text"
          label="Name"
          name="name"
          onChange={this.handleInputChange}
          value={this.props.macromolecule.name}
          validationState={this.props.validationStates.name}
        />

        <FormItem
          helpText={'Acronym will be used in the files and analysis. i.e: BSA. ' + this.props.helpBlockMessages.acronym}
          inputType="text"
          label="Acronym"
          name="acronym"
          onChange={this.handleInputChange}
          value={this.props.macromolecule.acronym}
          validationState={this.props.validationStates.acronym}
        />

        <FormItem
          helpText="Atomic mass estimation measured in Da"
          inputType="text"
          label="Mol. Mass (Da)"
          name="molecularMass"
          onChange={this.handleInputChange}
          value={this.props.macromolecule.molecularMass ? this.props.macromolecule.molecularMass : ''}
          validationState={this.props.validationStates.molecularMass}
        />

        <FormItem
          inputType="number"
          label="Extinction coef."
          name="extintionCoefficient"
          onChange={this.handleInputChange}
          value={this.props.macromolecule.extintionCoefficient ? this.props.macromolecule.extintionCoefficient : ''}
          validationState={this.props.validationStates.extintionCoefficient}
        />

        <FormGroup controlId="symmetry" validationState={this.props.validationStates.symmetry}>
          <Col componentClass={ControlLabel} sm={2}>
            Symmetry
          </Col>
          <Col sm={10}>
            <FormControl
              componentClass="select"
              name="symmetry"
              value={this.props.macromolecule.symmetry ? this.props.macromolecule.symmetry : ''}
              onChange={this.handleInputChange}
            >
              {this.getSymmetryOptionForSelect()}
            </FormControl>

            <FormControl.Feedback />
          </Col>
        </FormGroup>

        <FormItem
          helpText="How radiation propagates through the medium"
          inputType="number"
          label="Refractive Index"
          name="refractiveIndex"
          onChange={this.handleInputChange}
          value={this.props.macromolecule.refractiveIndex ? this.props.macromolecule.refractiveIndex : ''}
          validationState={this.props.validationStates.refractiveIndex}
        />

        <FormItem
          inputType="number"
          label="Solvent Viscosity"
          name="solventViscosity"
          onChange={this.handleInputChange}
          value={this.props.macromolecule.solventViscosity ? this.props.macromolecule.solventViscosity : ''}
          validationState={this.props.validationStates.solventViscosity}
        />

        <FormGroup controlId="comments" validationState={this.props.validationStates.comments}>
          <Col componentClass={ControlLabel} sm={2}>
            Comments
          </Col>
          <Col sm={10}>
            <FormControl
              componentClass="textarea"
              name="comments"
              rows={5}
              value={this.props.macromolecule.comments ? this.props.macromolecule.comments : ''}
              onChange={this.handleInputChange}
            />
            <FormControl.Feedback />
          </Col>
        </FormGroup>
      </Form>
    )
  }

  handleInputChange(event) {
    const target = event.target
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name

    this.props.setMacromolecule({ ...this.props.macromolecule, [name]: value })
  }

  getSymmetryOptionForSelect() {
    return [
      <option key="1" value="P1">
        P1
      </option>,
      <option key="2" value="P2">
        P2
      </option>,
      <option key="3" value="P3">
        P3
      </option>,
      <option key="4" value="P4">
        P4
      </option>,
      <option key="5" value="P5">
        P5
      </option>,
      <option key="6" value="P6">
        P6
      </option>,
      <option key="7" value="P32">
        P32
      </option>,
      <option key="8" value="P42">
        P42
      </option>,
      <option key="9" value="P52">
        P52
      </option>,
      <option key="10" value="P62">
        P62
      </option>,
      <option key="11" value="P222">
        P222
      </option>,
    ]
  }
}

MacromoleculeForm.propTypes = {
  /** Function triggered when the user change on of the inputs */
  setMacromolecule: PropTypes.func,
}

const FormItem = props => (
  <FormGroup validationState={props.validationState} controlId={props.name}>
    <Col componentClass={ControlLabel} sm={2}>
      {props.label}
    </Col>
    <Col sm={10}>
      <FormControl
        disabled={props.disabled === true}
        name={props.name}
        onChange={props.onChange}
        placeholder={props.label}
        type={props.inputType}
        value={props.value}
      />
      <FormControl.Feedback />
      {props.helpText ? <HelpBlock>{props.helpText}</HelpBlock> : null}
    </Col>
  </FormGroup>
)

class RigidBodyModelingForm extends React.Component {
  render() {
    return (
      <div>
        <p> Not implemented yet </p>
        {/* <p> Information for model fit, mixture analysis and rigid body modeling </p> */}
        {/* <p> Distance restraints may be imposed on the model using contacts conditions file (OPTIONAL) </p> */}
      </div>
    )
  }
}

export default SaxsNewOrEditMacromolecule

SaxsNewOrEditMacromolecule.propTypes = {}
